import { combineReducers } from 'redux';
import tags from './tags';

export default combineReducers({
  tags
});
